import makeStyles from '@mui/styles/makeStyles';
import { supportsDvh } from '../../../commons/utils/css';
const styles = (theme) => ({
  
  contentContainer: ({ viewAnimaiton, isPreview }) => {

    function getHeight () {
      if (supportsDvh()) {
        return '100dvh';
      }
      return '100vh';
    }

    const style =  {
      display: 'flex',
      height: getHeight(),
      width: '100%',
      flexDirection: 'column !important',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      overflow: 'auto',
    };

    if (viewAnimaiton) {
      style.backgroundColor = '#FFFFFF00';
    }

    if (isPreview) {
      style.backgroundColor = '#FFFFFF';
    }
    return style;
  },

  logoSpace: {
    position: 'absolute',
    top: '24px',
    left: '24px',
    height: 'auto',
    maxHeight: '200px',
  },

  logo: () => {
    return {
      width: '50%',
    };
  },
  
});

export default styles;
export const useStyles = makeStyles(styles);
